<template>
  <div class="box box-primary">
    <div class="box-header">
      <div class="row">
        <div class="col-md-3">
          <h3>{{ $t('fileBrowser.files.title') }}</h3>
        </div>
      </div>
    </div>
    <div class="box-body">
      <div class="row">
        <div id="matter-jarvis-drive-sharepoint">
          <div class="row text-center">
            <div>
              <img :src="logoUrl" alt="Sharepoint" title="Sharepoint"></div>
            <div>
              <a class="btn btn-primary" :href="sharepointLink" target="_blank">
                {{ $t('sharepoint.open_folder') }}
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SharepointLogo from '../../assets/images/sharepoint/logo.png'

export default {
  name: 'ShowSharepointLink',
  props: {
    sharepointLink: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      logoUrl: SharepointLogo,
      name: null
    }
  }
}
</script>

<style scoped>

</style>
